export async function fetchUserFull() {
    try {
        //const users = user.phoneNumber;
        //console.log("api 1 : ", user);
      const response = await fetch('https://yesedacademy.com/database/userProfile2.php', {
        method: 'POST',
        //body: JSON.stringify({ user}),
        headers: {
          'Content-Type': 'application/json',
        },
      });
     
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
  
      const details = await response.json();
      return details;
    } catch (error) {
      throw new Error('Error fetching user data:', error);
    }
  }

  export async function fetchUserStudent() {
    try {
        const user = 'Student';
        console.log("api 1 : ", user);
      const response = await fetch('https://yesedacademy.com/database/userProfileList.php', {
        
        method: 'POST',
        body: JSON.stringify({ user}),
        headers: {
          'Content-Type': 'application/json',
        },
        
      });
      
     
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
  
      const details = await response.json();
      return details;
    } catch (error) {
      throw new Error('Error fetching user data:', error);
    }
  }

  export async function fetchUserEmployee() {
    try {
        const user = 'Employee';
        console.log("api 2 : ", user);
      const response = await fetch('https://yesedacademy.com/database/userProfileList.php', {
        
        method: 'POST',
        body: JSON.stringify({ user}),
        headers: {
          'Content-Type': 'application/json',
        },
        
      });
      
     
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
  
      const details = await response.json();
      return details;
    } catch (error) {
      throw new Error('Error fetching user data:', error);
    }
  }

  export async function fetchUserDelete(postId, userType) {
    try {
        //const user = 'Employee';
        //console.log("api 2 : ", user);
      const response = await fetch('https://yesedacademy.com/database/userDelete.php', {
        
        method: 'POST',
        body: JSON.stringify({ postId, userType}),
        headers: {
          'Content-Type': 'application/json',
        },
        
      });
      
     
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
  
      const details = await response.json();
      return details;
    } catch (error) {
      throw new Error('Error fetching user data:', error);
    }
  }

  

  export async function fetchUserReviews(id) {
    try {
        //const users = user.phoneNumber;
        //console.log("api 1 : ", user);
      const response = await fetch('https://yesedacademy.com/database/reviewData.php', {
        method: 'POST',
        body: JSON.stringify({ id}),
        headers: {
          'Content-Type': 'application/json',
        },
      });
     
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
  
      const details = await response.json();
      return details;
    } catch (error) {
      throw new Error('Error fetching user data:', error);
    }
  }